import { formatToPercent } from "@inrev/common";
import {
	createSummaryTo,
	SummaryCardSection,
	SummaryField,
	SummaryFieldGroup,
	type SummaryFieldProps,
} from "@portal/components/multiform";
import { type ReactElement } from "react";
import { useFormContext } from "react-hook-form";
import { useLocation } from "react-router-dom";
import { formatEmpty } from "../../../../../../utils";
import { type AdminCombinedFormData, fp } from "../../schema";

export const BondTermsSummary = () => {
	const { getValues } = useFormContext<AdminCombinedFormData>();
	const { pathname } = useLocation();
	const terms = getValues().bondTerms;
	const to = createSummaryTo(pathname, "bondTerms");

	const fields: ReactElement<SummaryFieldProps>[] = [
		<SummaryField
			key="status"
			label="Status"
			value={formatEmpty(terms?.status)}
			fieldPath={fp("bondTerms.status")}
			to={to("bondTerms.status")}
		/>,
	];

	if (terms?.status === "approved") {
		fields.push(
			<SummaryField
				key="carrier"
				label="Carrier"
				value={formatEmpty(terms.carrierName)}
				fieldPath={fp("bondTerms.carrierName")}
				to={to("bondTerms.carrierName")}
			/>,
			<SummaryField
				key="rate"
				label="Rate"
				value={formatEmpty(formatToPercent(terms.rate))}
				fieldPath={fp("bondTerms.rate")}
				to={to("bondTerms.rate")}
			/>,
			<SummaryField
				key="agencyCommissionPercentage"
				label="Agency Commission"
				value={formatEmpty(formatToPercent(terms.agencyCommissionPercentage))}
				fieldPath={fp("bondTerms.agencyCommissionPercentage")}
				to={to("bondTerms.agencyCommissionPercentage")}
			/>,
		);
	}

	return (
		<SummaryCardSection header="Bond Terms" to={{ pathname, section: "bondTerms" }}>
			<SummaryFieldGroup>{fields}</SummaryFieldGroup>
		</SummaryCardSection>
	);
};
